var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 16 14 L 12 10 M 12 10 L 8 14 M 12 10 L 12 21 M 7.5 17 L 4.67 17 C 2.627 16.983 0.983 15.313 1 13.27 C 0.978 11.223 2.623 9.546 4.67 9.53 L 4.68 9.53 C 4.891 5.887 7.891 3.031 11.54 3 C 14.54 3 17.09 4.96 18.04 7.68 L 18.42 7.67 C 20.969 7.697 23.017 9.781 23 12.33 C 23.022 14.883 20.973 16.973 18.42 17 L 16 17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.fe6c6df416e7cd2b0c16cbd1bdb13507.svg";
export { ForwardRef as ReactComponent };